// src/lib/cancellation-policy-assignment-api.js
// Client admin de la GRILLE d'affectation « politique d'annulation par logement »
// (page Politiques → onglet Template, segment Direct). Écrit la colonne
// EXISTANTE logement_site_content.politique_annulation via /api/sites — action
// dédiée mince (cancellation_policy_assignment_*), sans toucher au contenu
// éditorial ni à la revalidation fbz-sites.
import { supabase } from '../supabase';

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Pas de session admin active. Reconnectez-vous.');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

async function parseOrThrow(res, fallback) {
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json?.ok) throw new Error(json?.error || fallback);
  return json;
}

/**
 * Liste les affectations courantes.
 * → { items: [{ logement_id, politique_annulation }] }
 * (le serveur applique le défaut 'non_remboursable' aux valeurs absentes).
 */
export async function fetchCancellationPolicyAssignments() {
  const res = await fetch('/api/sites?action=cancellation_policy_assignment_list', {
    headers: await authHeaders(),
  });
  return parseOrThrow(res, 'Chargement des affectations échoué');
}

/**
 * Affecte une politique à un logement.
 * → { ok, logement_id, politique_annulation }
 */
export async function setCancellationPolicyAssignment(logement_id, politique_annulation) {
  const res = await fetch('/api/sites?action=cancellation_policy_assignment_set', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ logement_id, politique_annulation }),
  });
  return parseOrThrow(res, 'Enregistrement échoué');
}
